import { jsx as _jsx } from "react/jsx-runtime";
import FlyoutUncontrolled from "./FlyoutUncontrolled.js";
import FlyoutControlled from "./FlyoutControlled.js";
import FlyoutTrigger from "./FlyoutTrigger.js";
import FlyoutContent from "./FlyoutContent.js";
const Flyout = (props) => {
    const { active } = props;
    if (typeof active === "boolean")
        return _jsx(FlyoutControlled, { ...props });
    return _jsx(FlyoutUncontrolled, { ...props });
};
Flyout.Trigger = FlyoutTrigger;
Flyout.Content = FlyoutContent;
Flyout.displayName = "Flyout";
export default Flyout;
